import PhotoContainerWrapper from '../src/PhotoContainerWrapper.tsx';
export default PhotoContainerWrapper;
